module.exports = __webpack_public_path__ + "static/oliver-2d6d26446a03c9ee77357fa674adeae5.png";